import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { mainBlueColor, workingBudgetData } from '../../GlobalState';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import { CustomTooltip } from '../../components/tooltip/CustomTooltip';
import { tooltipContents } from '../../components/tooltip/Const';
import HelpIcon from '@material-ui/icons/Help';

type TProps = {
  selectTab: number;
  setSelectTab: any;
};

/**
 * テーブルヘッダー
 * @constructor
 */
export const TabArea: React.FC<TProps> = (props: TProps) => {
  const { selectTab, setSelectTab } = props;

  const [mainColor] = useRecoilState(mainBlueColor);
  const matches2 = useMediaQuery('(min-width:960px)');
  const selectTabStyle = {
    backgroundColor: '#F5F5F5',
    borderTopColor: '#0099CB',
    borderBottom: 'none'
  };
  const classes = useStyles({ mainColor: mainColor });

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: matches2 ? 'row' : 'column'
      }}
      className={classes.topList}
    >
      <div
        // 空アイテム
        className='empty-list'
        style={{ width: 15 }}
      ></div>
      <div
        onClick={() => setSelectTab(0)}
        className='border2'
        style={selectTab == 0 ? selectTabStyle : {}}
      >
        <div
          className={
            selectTab == 0 ? classes.selectTopBoxText : classes.topBoxText
          }
        >
          見積書から引用
        </div>
      </div>
      <div
        onClick={() => setSelectTab(1)}
        className='border2'
        style={selectTab == 1 ? selectTabStyle : {}}
      >
        <div
          className={
            selectTab == 1 ? classes.selectTopBoxText : classes.topBoxText
          }
        >
          追加原価
          <CustomTooltip
            title={tooltipContents.AdditionalCostTab}
            placement='right'
          >
            <HelpIcon
              color='action'
              style={{ marginLeft: 8, marginBottom: 4 }}
            />
          </CustomTooltip>
        </div>
      </div>
      <div
        // 空アイテム
        className='empty-list'
        style={{ flexGrow: 1 }}
      ></div>
    </div>
  );
};

type TStyleProps = {
  mainColor: string;
};

const useStyles = makeStyles<Theme, TStyleProps>((theme: Theme) =>
  createStyles({})
);
